module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Horizontal-b1900be7b1f4a30a66cd20b90eb71db5.svg";